import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';

import {
  setPaymentInfo, doUpdateSubscription, doStoreChoosenPlanInfo, UPDATE_SUBSCRIPTION_SUCCESS, doReactivateSubscription, updateSubscriptionSuccess, REACTIVATE_SUBSCRIPTION_SUCCESS
} from '../actions/subscriptions';

import { withSubscription } from './withSubscription';

import UpdateSubscriptionPageComponent from '../components/subscriptions/UpdateSubscriptionPage';
import { withCurrentUser } from './withUser';
import { clearMessages } from '../actions/messages';
import { UPDATE_SUBSCRIPTION_ERROR } from '../actions/subscriptions';
import { setTargetPlanPeriodicity } from '../actions/products';

/**
 * Subscription Page container
 */

const mapStateToProps = (state, {subscription}) => {
  const currentSubscriptionPlanPeriodicity= subscription && subscription.plan && subscription.plan.periodicity;
  return {
    currentSubscriptionPlanPeriodicity,
    planTargetPeriodicity: state.planTargetPeriodicity
  };
}

const mapDispatchToProps = (dispatch, { subscription, navigateToSubscription}) => {

  return {
    // navigates to payment info page
    handleLockedSubscription : () => {
      if (subscription && subscription.locked) {
        navigateToSubscription(subscription.id)
      }
    },

    handlePlanTargetPeriodicity: (periodicity) => {
      dispatch(setTargetPlanPeriodicity(periodicity));
    },

    handlePaymentInfo: () =>
      dispatch(setPaymentInfo(subscription)),

    handlePlanChange: ({plan, licencesCount}) => {
      dispatch(doUpdateSubscription(subscription.id, plan.id, licencesCount))
      .then( res => {
        if (res.type === UPDATE_SUBSCRIPTION_ERROR) {
          const reason = res.error.errors.filter(err => err.reason === 'cantMigrateChargifySubscription')
          if (reason.length > 0) {
            dispatch(doStoreChoosenPlanInfo(plan.id, licencesCount));
            dispatch(clearMessages());
            dispatch(setPaymentInfo(subscription));
          } 
        }
        if (res.type === UPDATE_SUBSCRIPTION_SUCCESS) {
          const isRedirect = !res.subscription.hasPaymentInfo && !plan.isFree && res.subscription.status !== 'trialing';
          if (isRedirect) {
            dispatch(clearMessages());
            dispatch(setPaymentInfo(subscription));
          }
          if (res.subscription.status ==='trial_ended' || res.subscription.status === 'canceled') {
            dispatch(clearMessages());
            dispatch(doReactivateSubscription(res.subscription.id, false))
              .then(res => {
                // display the confirmation dialog only if the reactivation succeed
                if(res.type === REACTIVATE_SUBSCRIPTION_SUCCESS) {
                  dispatch(updateSubscriptionSuccess(subscription)); 
                }
              })
          }
        }   
      });
    },

    handleCurrentPlanUpdate: ({plan, licencesCount}) => {
      dispatch(doUpdateSubscription(subscription.id, plan.id, licencesCount))
      .then( res => {
        if (res.type === UPDATE_SUBSCRIPTION_ERROR) {
          const reason = res.error.errors.filter(err => err.reason === 'cantMigrateChargifySubscription')
          if (reason.length > 0) {
            dispatch(doStoreChoosenPlanInfo(plan.id, licencesCount));
            dispatch(clearMessages());
            dispatch(setPaymentInfo(subscription));
          } 
        }
        if (res.type === UPDATE_SUBSCRIPTION_SUCCESS) {
          const isRedirect = !res.subscription.hasPaymentInfo ;
          if (isRedirect) {
            dispatch(clearMessages());
            dispatch(setPaymentInfo(subscription));
          }
          if (res.subscription.status ==='trial_ended' || res.subscription.status === 'canceled') {
            dispatch(doReactivateSubscription(res.subscription.id, false));
          }
        }   
      });
    }
  }
}

const UpdateSubscriptionPage = compose(
  withSubscription,
  withCurrentUser,
  connect(mapStateToProps, mapDispatchToProps)
)(
  UpdateSubscriptionPageComponent
);

UpdateSubscriptionPage.propTypes = {
  subscriptionId: PropTypes.string.isRequired,
}

export default UpdateSubscriptionPage;


// WEBPACK FOOTER //
// ./src/containers/UpdateSubscriptionPage.js